import { useEffect, useState } from "react";
import { FormProps } from "../form/interface/formInterface";
import SmallForm from "../form/small_form";
import DivStyle from "../style/div.component";
import GameForm from "../form/game_form";
import GAMEAPI from "../../api/game";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { UserState } from "../../recoil/user.atom";
import API from "../../api/api";
import { loadingState } from "../../recoil/loading.atom";
import { IJoinSetting } from "./interface/interface";
import { IUser } from "../../pages/user/interface/interface";

const FriendSetting = () => {
  const mode = "S";
  const [usePointLimit, setUsePointLimit] = useState("");
  const [gamePointReward, setgamePointReward] = useState("");
  const [joinOldUserPointReward, setJoinOldUserPointReward] = useState("");
  const [joinNewUserPointReward, setJoinNewUserPointReward] = useState("");
  const [joinNewSoloUserPointReward, setJoinNewSoloUserPointReward] =
    useState("");
  const [rebuyinReward, setRebuyinReward] = useState("");
  const [frNickName, setfrNickName] = useState("");
  const [frUser, setFrUser] = useState<IUser | null>(null);
  const user: any | IUser = useRecoilValue(UserState);
  const setIsLoading = useSetRecoilState(loadingState);

  const save = async () => {
    const body = {
      rebuyinReward,
      gamePointReward,
      joinOldUserPointReward,
      joinNewUserPointReward,
      joinNewSoloUserPointReward,
      usePointLimit,
      password: "qlrnqofiwjdo1932938@#@#1",
    };
    if (window.confirm("수정 하시겠습니까?")) {
      setIsLoading(true);
      const res = await GAMEAPI.saveGameSetting(body);
      if (res) {
        if (res.status === 200) {
          alert("수정되었습니다.");
          getJoinSetting();
        } else {
          alert("수정에 실패하였습니다.");
        }
      }
      setIsLoading(false);
    }
  };

  const getJoinSetting = async () => {
    const res = await GAMEAPI.getJoinSetting();
    if (res && res.status) {
      const data = res.data;
      const usePointLimit = data.find(
        (o: IJoinSetting) => o.name === "usePointLimit"
      );
      const gamePointReward = data.find(
        (o: IJoinSetting) => o.name === "gamePointReward"
      );
      const joinOldUserPointReward = data.find(
        (o: IJoinSetting) => o.name === "joinOldUserPointReward"
      );
      const joinNewUserPointReward = data.find(
        (o: IJoinSetting) => o.name === "joinNewUserPointReward"
      );
      const joinNewSoloUserPointReward = data.find(
        (o: IJoinSetting) => o.name === "joinNewSoloUserPointReward"
      );
      const fr = data.find((o: IJoinSetting) => o.name === "rebuyinReward");

      if (usePointLimit) {
        setUsePointLimit(usePointLimit.value);
      }
      if (gamePointReward) {
        setgamePointReward(gamePointReward.value);
      }
      if (joinOldUserPointReward) {
        setJoinOldUserPointReward(joinOldUserPointReward.value);
      }
      if (joinNewUserPointReward) {
        setJoinNewUserPointReward(joinNewUserPointReward.value);
      }
      if (joinNewSoloUserPointReward) {
        setJoinNewSoloUserPointReward(joinNewSoloUserPointReward.value);
      }
      if (fr) {
        setRebuyinReward(fr.value);
      }
    }
  };
  useEffect(() => {
    getJoinSetting();
  }, []);
  const formData: FormProps = {
    title: "토너먼트 입장 설정",
    form: [
      {
        value: usePointLimit,
        setValue: setUsePointLimit,
        label: "게임 머니 사용 최대 값",
        type: "input",
        width: "100%",
      },
      {
        value: joinOldUserPointReward,
        setValue: setJoinOldUserPointReward,
        label: "친구 추천 받은 회원이 받는 게임 머니 (기존회원)",
        type: "input",
        width: "100%",
      },
      {
        value: joinNewUserPointReward,
        setValue: setJoinNewUserPointReward,
        label: "친추 추천 한 회원이 받는 게임 머니 (신규회원)",
        type: "input",
        width: "100%",
      },
      {
        value: joinNewSoloUserPointReward,
        setValue: setJoinNewSoloUserPointReward,
        label: "친구 추천 없이 게임 첫 접속 시 받는 게임 머니 (신규회원)",
        type: "input",
        width: "100%",
      },
      {
        value: rebuyinReward,
        setValue: setRebuyinReward,
        label: "리바인",
        type: "input",
        width: "100%",
      },
    ],
  };

  return (
    <DivStyle
      width="100%"
      backgroundColor="#121212"
      height="auto"
      display="flex"
      flex_direction="row"
      justify_content="center"
      setMobile={true}
    >
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <GameForm
            form={formData.form}
            title={formData.title}
            save={save}
            mode={mode}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default FriendSetting;
